export class Team {
  Id: number;
  RecordId: number;
  CreatedBy: number;
  CreatedDate: string;
  EntityId: number;
  EntityTypeId: number;
  ModifiedBy: number;
  ModifiedDate: string;
  Name: string;
  IsDeleted: boolean;

  constructor(obj?: Partial<Team>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }
}

export enum TeamType {
  Project = 29,
  Personal = 47,
}
